import React from 'react';

const highlights = [
  'Canli mac akisi ve premium veri odakli deneyim',
  'Son 20 mac formu ve xG tabanli derin analiz',
  'Premium uye olanlar icin derin analiz ve kupon vitrini'
];

const AuthShowcase = () => (
  <div className="auth-showcase">
    <div className="auth-showcase-backdrop"></div>
    <div className="auth-showcase-content">
      <span className="showcase-badge">Canli Veri + AI Tahmin</span>
      <img src="/tahminarena-logo.png" alt="TahminArena logo" className="auth-logo" />
      <h1>Futbol tutkusunu premium bir tahmin arenasina cevirin.</h1>
      <p>
        TahminArena, stadyum enerjisini modern veri arayuzu ile birlestirir.
        Giren kullaniciya hiz, heyecan ve premium bir ritim verir.
      </p>
      <div className="showcase-points">
        {highlights.map((item) => (
          <div key={item} className="showcase-point">
            <span className="point-dot"></span>
            <span>{item}</span>
          </div>
        ))}
      </div>
    </div>
  </div>
);

export default AuthShowcase;
